<template>
  <div class="d-flex" :title="'Observed by ' + formattedObservationCard.observerName">
    <div class="card ml-0 mr-1 text-center text-center">
      <div class="card-body">
        <div class="d-flex card-content">
          <div class="my-0 card-image-container overflow-hidden">
            <div class=""
                 @click="(evt) => { handleViewDetail(observation.id) }" title="Click to View Details">
              <b-card-img :src="formattedObservationCard.observationPicture" alt="Image" :top="true" :fluid="true"
                          class="pt-1 px-1"/>
            </div>
          </div>
        </div>
        <div class="row mt-3 mx-1 green-band">
          <div class="ml-1 mt-1 font-weight-bold name-holder">
            {{ ellipsizeCharacters(formattedObservationCard.observerName, 18) }}
          </div>
          <div class="avatar-holder mr-1 mx-0">
            <b-img thumnbnail rounded="circle"
                   :src="formattedObservationCard.observerPicture"
                   class="avatar border-white"/>
          </div>
        </div>
        <div class="row text-left my-0 mt-3">
          <div class="col-1 ml-3">
            <i class="fas fa-binoculars"></i>
          </div>
          <div class="col-10 details">
            <span :title="'Observed At: '+ formattedObservationCard.observedAt">{{
                ellipsizeCharacters(displayFormattedDate(formattedObservationCard.observedAt), 24)
              }}</span>
          </div>
        </div>
        <div class="row text-left my-0">
          <div class="col-1 ml-3">
            <i class="fa fa-map-marker-alt"></i>
          </div>
          <div class="col-10 details">
            <b-link :to="{ name: 'LocationDetails', params: { id: formattedObservationCard.locationId } }"
                    :title="'Observation Location: '+ formattedObservationCard.locationName"
                    :alt="'Observation Location: '+ formattedObservationCard.locationName">
              {{ ellipsizeCharacters(formattedObservationCard.locationName, 24) }}
            </b-link>
          </div>
        </div>
        <div class="row text-left my-0">
          <div class="col-1 ml-3">
            <i class="fa fa-rectangle-list"></i>
          </div>
          <div class="col-10 details">
              <span :title="'Datasheet: ' + formattedObservationCard.datasheetName">
                {{
                  formattedObservationCard.datasheetName ? ellipsizeCharacters(formattedObservationCard.datasheetName, 23) : ""
                }}
              </span>
          </div>
        </div>
        <div class="card-footer p-0">
          <div class="row justify-content-between align-items-center m-0 ml-2">
            <div class="col-xs-6">
            </div>
            <div class="col-xs-3">
            </div>
            <div class="col-xs-3">
              <b-dropdown
                right
                split
                size="sm"
                class="m-1"
                alt="View Details"
                title="View Details"
                split-variant="outline-secondary"
                @click="handleViewDetail(observation.id)"
              >
                <template slot="button-content">
                  <i class="fa fa-eye"></i> View Details
                </template>
                <b-dropdown-item
                  v-if="isManager"
                  @click="handleDelete(observation)"
                  alt="Delete this Observation"
                  title="Delete this Observation"
                >
                  <i class="fa fa-trash mr-1 mr-lg-2"></i>Delete
                </b-dropdown-item>
                <b-dropdown-item
                  @click="handleView(observation.id)"
                  alt="View Observation (new tab)"
                  title="View Observation (new tab)"
                >
                  <i class="fa fa-eye"></i> View (new tab) <i class="fas fa-external-link-alt fa-xs"></i>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import DateTime from "../../../common/date-time/DateTime.vue";
import CitSciProjectIcon from "../../../common/CitSciProjectIcon.vue";

export default {
  name: "ProjectObservationCard",
  components: {CitSciProjectIcon, DateTime},
  props: {
    observation: {
      type: Object,
      required: true,
    },
    handleViewDetail: {
      type: Function,
      required: true
    },
    handleView: {
      type: Function,
      required: true
    },
    handleDelete: {
      type: Function,
      required: true
    },
  },
  data() {
    return {};
  },
  created() {
  },
  computed: {
    ...mapGetters({
      isManager: "project/get/isManager",
    }),
    // Computed getter for formatted observation card
    formattedObservationCard() {

      // Return our formatted observation card with images
      if (this.observation) {

        let observationCardTemplate = {}
        let bFoundImg = false

        // set the observation id
        observationCardTemplate.id = this.observation.id

        // set the observation image
        observationCardTemplate.observationPicture = '/assets/images/generic_img.png'
        if (this.observation.featuredPhoto) {
          observationCardTemplate.observationPicture = this.observation.featuredPhoto.path
        }

        // set the observer's name
        observationCardTemplate.observerName = this.observation.user.displayName

        // set the observer profile image placeholder
        observationCardTemplate.observerPicture = this.observation.user.picture ? this.observation.user.picture.path : '/assets/images/default_avatar.png'

        // set the observed data
        observationCardTemplate.observedAt = this.observation.observedAt

        // datasheet details are set
        observationCardTemplate.datasheetName = (this.observation && this.observation['datasheet']) ? this.observation.datasheet.name : "No Datasheet"
        observationCardTemplate.datasheetURL = null

        // set the location id and name
        observationCardTemplate.locationId = this.observation.location.id
        observationCardTemplate.locationName = this.observation.location.name

        // Return the observation card
        return observationCardTemplate
      }
      return null
    },
  },
  methods: {}
};
</script>

<style lang="scss" scoped>

.card-image-container {
  min-height: 150px;
  max-height: 150px;
  min-width: 235px;
}

.card-body {
  max-width: 235px;
  max-height: 251px;
  min-height: 251px;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;

  .card-content, {
    flex-direction: column;
    overflow: hidden;
  }

  .green-band {
    background: #A3B266;
    padding: 0;
    margin-top: 0 !important;
    max-height: 27px;
    color: #fff;
    justify-content: space-between;

    & > .avatar-holder {
      text-align: right;
      margin-top: -15px;
      display: inline;
    }
  }
}
</style>

